import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core';

export default function MaterialThemeProvider(props) {
  const theme = React.useMemo(
    () =>
      createMuiTheme({
        palette: {
          type: props.darkMode ? 'dark' : 'light',
          primary: {
            main: '#037Ef3',
            light: '#0CB9C1',
          },
          secondary: {
            main: '#F85A40',
            light: '#F48924',
          },
          common: {
            white: '#fff',
            black: '#000',
          },
        },
      }),
    [props.darkMode]
  );
  return <ThemeProvider theme={theme}>{props.children}</ThemeProvider>;
}
